export default __webpack_public_path__ + "static/media/ellen.d2fb9986.jpg";